import { IPatient, IAdmission, Admission, v2 } from '../../..';

type AdmissionParts = Pick<
    IPatient,
    'referralDateTime' | 'referralPathway' | 'referredBy' | 'referrer' | 'systmOneRef' | 'admission'
>;

export const admissionAdapter = (admission: v2.Admission): AdmissionParts => {
    const {
        referralDateTime,
        referralPathway,
        referredBy,
        referrer,
        systmOneRef,
        admissionStatuses,
    } = admission;

    const admittedStatus = admissionStatuses?.find(
        (status) => status.statusTypeId === Admission.ADMITTED,
    );
    const dischargedStatus = admissionStatuses?.find(
        (status) => status.statusTypeId === Admission.DISCHARGED,
    );

    let v1Admission: IAdmission | undefined;

    if (admittedStatus) {
        v1Admission = {
            isAdmitted: true,
            admittedAt: admittedStatus.confirmedAt.toISOString(),
            admittedBy: admittedStatus.confirmedBy,
        };
    }

    if (dischargedStatus) {
        v1Admission = {
            ...v1Admission,
            isAdmitted: false,
            dischargedAt: dischargedStatus.confirmedAt.toISOString(),
            dischargedBy: dischargedStatus.confirmedBy,
        };
    }

    return {
        referralDateTime: referralDateTime?.toISOString() || undefined,
        referralPathway: referralPathway || undefined,
        referredBy: referredBy || undefined,
        referrer: referrer || undefined,
        systmOneRef: systmOneRef || undefined,
        admission: v1Admission,
    };
};
